/**
 * Garde KITT pour le mode démonstration.
 * En démo, toute tentative de lancement de KITT (chat, synthèse, bordereaux,
 * devis, formulaires IA, email IA...) est bloquée et affiche une modale d'information.
 *
 * Usage :
 *   const guardKitt = useKittGuard();
 *   const onLaunch = () => { if (guardKitt()) return; ...lancer KITT... };
 */
import { useCallback } from 'react';
import { useIsDemo } from './useIsDemo';

export const KITT_DEMO_EVENT = 'kitt-demo-blocked';

export const openKittDemoNotice = () => {
  window.dispatchEvent(new CustomEvent(KITT_DEMO_EVENT));
};

export const useKittGuard = () => {
  const isDemo = useIsDemo();
  return useCallback(() => {
    if (isDemo) {
      openKittDemoNotice();
      return true;
    }
    return false;
  }, [isDemo]);
};
